// Tiny pub/sub so any part of the app can ask the tray's "Recent recordings" list (decision #5)
// to refresh without importing TraySync directly — same shape as devMode.ts's subscribe*().
// RecorderPage calls requestTrayRefresh() once a recording publishes; TraySync is the only
// subscriber today.
const listeners = new Set<() => void>();

export function requestTrayRefresh(): void {
  listeners.forEach((listener) => listener());
}

/** Returns an unsubscribe function. */
export function subscribeTrayRefresh(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
